import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./LoginPage.css";
import APP_VERSION from "../version";

function HomePage({ currentUser, setCurrentUser }) {
  const navigate = useNavigate();
  const [trips, setTrips] = useState([]);

  useEffect(() => {
    if (!currentUser) {
      navigate("/login", { replace: true });
      return;
    }

    const fetchTrips = async () => {
      try {
        const res = await fetch("/api/trips", { credentials: "include" });
        const data = await res.json();
        if (res.ok) {
          setTrips(data.trips || []);
        } else {
          console.error("Failed to fetch trips:", data.error);
        }
      } catch (err) {
        console.error("Error fetching trips:", err);
      }
    };

    fetchTrips();
  }, [currentUser, navigate]);

  const handleLogout = async () => {
    await fetch("/auth/logout", { credentials: "include" });
    setCurrentUser(null);
    navigate("/login", { replace: true });
  };

  if (!currentUser) return null;

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/campwithfriends-logo.png"
          alt="Camp With Friends Logo"
          style={{
            width: "200px",
            marginBottom: "20px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />

        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
          Welcome back, {currentUser.name || currentUser.email}
        </h2>

        {/* Trips badge box */}
<div
  style={{
    backgroundColor: "#f8f8f8",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "20px",
    marginBottom: "20px",
    textAlign: "center",
  }}
>
  <h3 style={{ marginBottom: "15px" }}>Your trips!</h3>

  {trips.length === 0 ? (
    <>
      <img
        src="/sad-camper-image.png"
        alt="No trips"
        style={{ width: "120px", marginBottom: "10px" }}
      />
      <p style={{ color: "#777", fontSize: "14px" }}>
        Looks like you have no trips planned. Click Create your next trip
        button below!
      </p>
    </>
  ) : (
          <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              {trips.map((trip) => {
                const isOwner = trip.creator_profile_id === currentUser.profile_id;

                // Format dates nicely
                const formatDate = (dateStr) => {
                  const date = new Date(dateStr);
                  return date.toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  });
                };

                // Determine attendance label
                const statusText = isOwner
                  ? "Going"
                  : trip.attending === true
                  ? "Going"
                  : trip.attending === false
                  ? "Not going"
                  : "Pending";

                return (
                  <Link
                    to={`/trip/${trip.id}`}
                    key={trip.id}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      backgroundColor: isOwner ? "#2c7373" : "#888",
                      padding: "12px 18px",
                      borderRadius: "12px",
                      fontSize: "0.95em",
                      textAlign: "left",
                      width: "100%",
                      maxWidth: "400px",
                    }}
                  >
                    <div style={{ fontWeight: "bold", fontSize: "1.05em" }}>
                      {trip.trip_name || "Unnamed Trip"}
                    </div>
                    <div style={{ margin: "4px 0" }}>
                      Owner: {isOwner ? "You" : trip.creator_name}
                    </div>
                    <div style={{ margin: "4px 0" }}>
                      Location: {trip.location_name}
                    </div>
                    <div style={{ margin: "4px 0" }}>
                      Dates: {formatDate(trip.start_date)} → {formatDate(trip.end_date)}
                    </div>
                    <div style={{ margin: "4px 0", fontStyle: "italic" }}>
                      Status: {statusText}
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>

        {/* Create Trip Button */}
        <button
          className="green-button"
          onClick={() => navigate("/createtrip")}
          style={{ marginBottom: "20px", fontSize: "1em" }}
        >
          Create your next trip!
        </button>
        <button
          className="green-button"
          onClick={() => navigate("/profile")}
          style={{ marginBottom: "20px", fontSize: "1em" }}
        >
          Update Your Profile
        </button>

        {/* Footer with version and links */}
        <div
          className="version-text"
          style={{
            fontSize: "12px",
            color: "#ccc",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "30px",
          }}
        >
          <span>
            Version: <strong>{APP_VERSION}</strong>
          </span>
          <span>
            <div className="footer-links">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                }}
                className="footer-link"
              >
                Logout
              </Link>
              <Link to="/contact" className="footer-link">
                Contact us
              </Link>
            </div>
          </span>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
